import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Static, Input, Checkbox } from '../../../../common/components/formControls';
import { Field } from 'redux-form';
import { FormGroup, ControlLabel, FormControl, Button, Alert } from 'react-bootstrap';
import validators from '../../../../common/services/validators';
import {
    revokeAccessToken, STRIPE_REVOKE_ACCESS_TOKEN_REQUEST, STRIPE_REVOKE_ACCESS_TOKEN_SUCCESS, STRIPE_REVOKE_ACCESS_TOKEN_FAILURE,
    requestOAuthLink, STRIPE_OAUTH_LINK_REQUEST, STRIPE_OAUTH_LINK_SUCCESS, STRIPE_OAUTH_LINK_FAILURE,
    checkOnboardingStatus, STRIPE_ONBOARDING_STATUS_REQUEST, STRIPE_ONBOARDING_STATUS_SUCCESS, STRIPE_ONBOARDING_STATUS_FAILURE
} from './actions';
import { PAYMENT_METHODS_REQUEST, PAYMENT_METHODS_SUCCESS, PAYMENT_METHODS_FAILURE } from '../../actions';
import ReduxBlockUi from 'react-block-ui/redux';
import { getLocationPathByPaymentOwner } from '../common';
import { withTranslation, Trans } from 'react-i18next';
import AuthorizationRedirect from './AuthorizationRedirect';

class StripeForm extends Component {
    constructor(props) {
        super(props);
        this.handleConnectToLive = this.handleConnectToLive.bind(this);
        this.handleConnectToSandbox = this.handleConnectToSandbox.bind(this);
        this.handleDisconnect = this.handleDisconnect.bind(this);
        this.handleContinueOnboarding = this.handleContinueOnboarding.bind(this);

        this.state = {
            redirect: false,
            useSandbox: true,
            status: {
                error: false,
                errorMessage: '',
                connectedAccountId: '',
                detailsSubmitted: false,
                chargesEnabled: false
            }
        };
    }

    componentDidMount() {
        const { checkOnboardingStatus, paymentConfigurationId, configurationValues } = this.props;
        const connected = configurationValues && configurationValues.connectedAccountId;

        if (connected) {
            checkOnboardingStatus({ paymentConfigurationId },
                response => this.setState({ status: { error: false, ...response } }),
                errorResponse => this.setState({ status: { error: true, errorMessage: errorResponse } })
            );
        }
    }

    handleConnectToLive() {
        this.setState({
            redirect: true,
            useSandbox: false
        });
    }

    handleConnectToSandbox() {
        this.setState({
            redirect: true,
            useSandbox: true
        });
    }

    handleDisconnect() {
        const { paymentConfigurationId, revokeAccessToken, onConfigurationUpdated } = this.props;
        revokeAccessToken({ paymentConfigurationId }, onConfigurationUpdated);
    }

    handleContinueOnboarding() {
        const {
            paymentConfigurationId, requestOAuthLink, onConfigurationUpdated,
            paymentOwnerType, paymentOwnerId, franchiseeId
        } = this.props;

        const returnPath = `${getLocationPathByPaymentOwner(paymentOwnerType, paymentOwnerId, franchiseeId)}?method=stripe`;

        requestOAuthLink(
            {
                paymentConfigurationId,
                returnPath,
                refreshPath: `/payments/stripe/refresh-callback?paymentConfigurationId=${paymentConfigurationId}&returnPath=${encodeURIComponent(returnPath)}`
            },
            onConfigurationUpdated,
            errorResponse => this.setState({ status: { error: true, errorMessage: errorResponse } }));
    }

    render() {
        const { t, enabled, configurationValues, onSubmit, ...rest } = this.props;
        const connected = configurationValues && configurationValues.connectedAccountId;
        const connectedToSandbox = connected && configurationValues.useSandbox;

        const { error, errorMessage, connectedAccountId, detailsSubmitted, chargesEnabled } = this.state.status;

        return (
            <div>
                <FormGroup>
                    {enabled && !connected && !connectedToSandbox && <Alert bsStyle='warning'>
                        {t('Stripe_EnabledNotConnected')}
                    </Alert>}
                    <ControlLabel>{t('Stripe_ConnectDisconnect')}</ControlLabel>
                    <FormControl.Static>
                        <ReduxBlockUi
                            block={[STRIPE_REVOKE_ACCESS_TOKEN_REQUEST, STRIPE_OAUTH_LINK_REQUEST, PAYMENT_METHODS_REQUEST]}
                            unblock={[STRIPE_REVOKE_ACCESS_TOKEN_SUCCESS, STRIPE_REVOKE_ACCESS_TOKEN_FAILURE, STRIPE_OAUTH_LINK_FAILURE, PAYMENT_METHODS_SUCCESS, PAYMENT_METHODS_FAILURE]}>
                            {!connected && <Button bsStyle='primary' onClick={this.handleConnectToLive}>{t('Stripe_Connect')}</Button>}
                            {!connected && <div className='help' style={{ paddingLeft: 0 }}>You'll be redirected to Stripe to complete the onboarding process.</div>}
                            {!connected && <a style={{ display: 'block', marginTop: '15px', cursor: 'pointer' }} onClick={this.handleConnectToSandbox}>{t('Stripe_ConnectSandbox')}</a>}
                            {connected && <Button bsStyle='primary' onClick={this.handleDisconnect}>{t(connectedToSandbox ? 'Stripe_DisconnectSandbox' : 'Stripe_Disconnect')}</Button>}
                            {connected && <div style={{ marginTop: '15px' }}>
                                <ReduxBlockUi block={STRIPE_ONBOARDING_STATUS_REQUEST} unblock={[STRIPE_ONBOARDING_STATUS_SUCCESS, STRIPE_ONBOARDING_STATUS_FAILURE]} renderChildren={false}>
                                    {error ? <Alert bsStyle='danger'>
                                        <div style={{ marginBottom: '10px' }}><strong>{t('Stripe_OnboardingStatus_Error')}</strong></div>
                                        <div>{errorMessage}</div>
                                    </Alert> :
                                        detailsSubmitted && chargesEnabled ?
                                            <Alert bsStyle='success'>
                                                <div style={{ marginBottom: '10px' }}><strong>{t('Stripe_OnboardingStatus_Completed')}</strong></div>
                                                <p>{t('Stripe_OnboardingStatus_Account', { connectedAccountId })}</p>
                                                <p>{t('Stripe_OnboardingStatus_Completed_Description')}</p>
                                            </Alert> :
                                            <Alert bsStyle='warning'>
                                                <div style={{ marginBottom: '10px' }}><strong>{t('Stripe_OnboardingStatus_ActionRequired')}</strong></div>
                                                <p>{t('Stripe_OnboardingStatus_Account', { connectedAccountId })}</p>
                                                <p>
                                                    <Trans i18nKey='Stripe_OnboardingStatus_ActionRequired_Description'>
                                                        <a onClick={this.handleContinueOnboarding} style={{ fontWeight: 'bold', cursor: 'pointer' }}>Click here</a> to complete your business details before you can start receiving payments.
				                                    </Trans>
                                                </p>
                                            </Alert>}
                                </ReduxBlockUi >
                            </div>}
                            {this.state.redirect && <AuthorizationRedirect useSandbox={this.state.useSandbox} {...rest} />}
                        </ReduxBlockUi>
                    </FormControl.Static>
                </FormGroup>
                {/* Deliberately hidden rather than deleted - kept for re-enabling during support work. */}
                {/* eslint-disable-next-line no-constant-binary-expression */}
                {false && <Field name='connectedAccountId' component={Static} type='text' label={t('Stripe_ConnectedAccountId')} />}
                <Field name='additionalFee' component={Input} type='text' label={t('PaymentMethod_AdditionalFee')} validate={[validators.number]} />
                <Field name='isAdditionalFeePercentage' component={Checkbox} label={t('PaymentMethod_IsAdditionalFeePercentage')} help={t('PaymentMethod_AdditionalFeeComplianceNote')} normalize={v => !!v} />
            </div>
        );
    }
}

export default connect(null, {
    revokeAccessToken,
    requestOAuthLink,
    checkOnboardingStatus
})(withTranslation()(StripeForm));